<template>
  <SideBar :sidebarItems="sidebarItems" companyType="charterer"/>
</template>

<script setup>
import SideBar from "@/components/organisms/SideBar.vue";

const sidebarItems = [
  {icon: "graph", label: "Dashboard", to: {name: "Dashboard"}},
  {icon: "takeoff", label: "Charter Requests", to: {name: "ChartererRequestList"}},
  {icon: "contract", label: "Contracts",to: {name: "ChartererContracts"}},
  {icon: "box", label: "Shipments", to: {name: "ChartererShipments"}},
  {icon: "message", label: "Message", badge: 3, to: {name: "ChartererMessages"}},
]
</script>

<style scoped>

</style>